import { useEffect } from "react";
import { usePatchPortfolioCryptocurrenciesMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPortfolioCryptocurrenciesMutation";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { getCryptocurrencyFormSchema } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/cryptocurrencyFormSchema";
import { mapPortfolioToCryptocurrencyForm } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/mapPortfolioToCryptocurrencyForm";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditCryptocurrencyFormArgs = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const useEditCryptocurrencyForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: UseEditCryptocurrencyFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } =
		usePatchPortfolioCryptocurrenciesMutation(portfolioId);

	const { form, onSubmit } = useEditPortfolioForm({
		schema: getCryptocurrencyFormSchema(t),
		defaultValues: mapPortfolioToCryptocurrencyForm(portfolio),
		mutate,
		successToast: t(Resources.Portfolio.EditPortfolio.savedToast, {
			type: getPortfolioTitle(portfolio, t),
		}),
		redirectTo: detailRoute,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending };
};
